import { parseISO } from 'date-fns';

import {
    PhoneCall,
    DossierPhoneCallApi,
    PhoneCallToken,
    PhoneCallTokenJSONAPIResponse,
    TimestampedWord,
    PhoneCallSummaryMail,
    PhoneCallSummaryMailJSONAPIResponse,
} from './types';

export const serializePhoneCallsFromAPI = (phoneCalls: DossierPhoneCallApi[]): PhoneCall[] =>
    phoneCalls.map((phoneCall) => ({
        id: phoneCall.phoneCallId,
        dossier_phone_call_id: phoneCall.dossierPhoneCallId,
        date: phoneCall.phoneCallCreatedAt ? parseISO(phoneCall.phoneCallCreatedAt) : new Date(),
        sendDate: phoneCall.phoneCallCreatedAt
            ? parseISO(phoneCall.phoneCallCreatedAt)
            : new Date(),
        duration: phoneCall.phoneCallDuration || 0,
        state: 1, // completed
        raw_transcription: phoneCall.transcript || null,
        summary: phoneCall.summary || '',
        audio_file: phoneCall.recordingAudioFileUrl || '',
        timestamped_transcript: parseTimestampedTranscript(phoneCall.timestampedTranscript),
        transcript_error_code: phoneCall.transcriptErrorCode || null,
        summary_error_code: phoneCall.summaryErrorCode || null,
        transcript_deleted_at: phoneCall.transcriptDeletedAt
            ? parseISO(phoneCall.transcriptDeletedAt)
            : null,
        recording_audio_file_deleted_at: phoneCall.recordingAudioFileDeletedAt
            ? parseISO(phoneCall.recordingAudioFileDeletedAt)
            : null,
    }));

const parseTimestampedTranscript = (timestampedTranscript: unknown): TimestampedWord[] => {
    if (typeof timestampedTranscript === 'string') {
        try {
            const parsed = JSON.parse(timestampedTranscript);
            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            console.error('Error parsing timestamped_transcript:', error);
            return [];
        }
    }

    return [];
};

export const serializePhoneCallTokenFromApi = ({
    data: {
        attributes: { token, phoneCallId },
    },
}: PhoneCallTokenJSONAPIResponse): PhoneCallToken => {
    return {
        token,
        phoneCallId,
    };
};

export const serializePhoneCallSummaryMailFromAPI = ({
    data: { attributes },
}: PhoneCallSummaryMailJSONAPIResponse): PhoneCallSummaryMail => {
    return {
        content: attributes.content,
    };
};
